var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Twitter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.325,
    height: 13.284,
    viewBox: "0 0 16.325 13.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.325,1.574A6.771,6.771,0,0,1,14.4,2.1,3.361,3.361,0,0,0,15.876.249a6.655,6.655,0,0,1-2.128.813,3.348,3.348,0,0,0-5.795,2.29,3.279,3.279,0,0,0,.086.765A9.492,9.492,0,0,1,1.135.612,3.356,3.356,0,0,0,2.176,5.089,3.271,3.271,0,0,1,.654,4.67v.042A3.352,3.352,0,0,0,3.342,8a3.372,3.372,0,0,1-.882.118,3.16,3.16,0,0,1-.63-.062,3.355,3.355,0,0,0,3.131,2.328A6.715,6.715,0,0,1,.8,11.818a6.789,6.789,0,0,1-.8-.048,9.362,9.362,0,0,0,5.127,1.515,9.473,9.473,0,0,0,9.538-9.541c0-.145,0-.291-.01-.432A6.818,6.818,0,0,0,16.325,1.574Z",
    transform: "translate(0)",
    fill: "#4b4aee"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d10dfa67.svg";
export { ForwardRef as ReactComponent };